/* Find my size — altura e peso viram um tamanho.
 *
 * A conta NAO e formula minha. Sai das colunas de altura e peso do
 * custom.size_table do proprio produto, que vem do fabricante. Produto sem
 * essas duas colunas preenchidas nao ganha o botao: e melhor nao responder do
 * que responder um chute com cara de calculo.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-fit]');
  var drawer = document.getElementById('FitFinder');
  if (!root || !drawer) return;

  /* ------------------------------------------------------------- a tabela */
  var raw = '';
  var src = document.getElementById('fit-data');
  if (src) {
    try { raw = JSON.parse(src.textContent) || ''; } catch (e) { raw = ''; }
  }

  /* "165–170", "165-170", "45 – 55" -> {lo, hi} */
  function range(s) {
    var m = String(s).replace(/[–—]/g, '-').match(/(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)/);
    return m ? { lo: parseFloat(m[1]), hi: parseFloat(m[2]) } : null;
  }

  var have = (root.getAttribute('data-sizes') || '').split(',').map(function (s) {
    return s.trim().toLowerCase();
  });

  var rows = [];
  (function parse() {
    var lines = String(raw).split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
    if (lines.length < 2) return;

    var head = lines[0].split('|').map(function (c) { return c.trim().toLowerCase(); });
    var hi = -1, wi = -1, ci = -1;
    head.forEach(function (h, i) {
      if (hi < 0 && h.indexOf('height') === 0) hi = i;
      if (wi < 0 && h.indexOf('weight') === 0) wi = i;
      if (ci < 0 && h.indexOf('chest') === 0) ci = i;
    });
    if (hi < 0 || wi < 0) return;

    lines.slice(1).forEach(function (line) {
      var c = line.split('|').map(function (x) { return x.trim(); });
      var h = range(c[hi]), w = range(c[wi]);
      if (!h || !w || !c[0]) return;
      /* So os tamanhos que esta peca realmente tem. */
      if (have.length && have.indexOf(c[0].toLowerCase()) < 0) return;
      rows.push({ size: c[0], h: h, w: w, chest: ci >= 0 ? c[ci] : '' });
    });
  })();

  if (!rows.length) return;

  /* ------------------------------------------------------------ a escolha
   * Altura e peso sao dois palpites sobre a mesma pessoa e as vezes discordam.
   * Quando discordam vai o MAIOR, e a tela diz que discordaram — esconder o
   * desacordo seria vender confianca que o dado nao tem.
   */
  function pick(cm, kg) {
    var byH = [], byW = [];
    rows.forEach(function (r, i) {
      if (cm >= r.h.lo && cm <= r.h.hi) byH.push(i);
      if (kg >= r.w.lo && kg <= r.w.hi) byW.push(i);
    });

    var both = byH.filter(function (i) { return byW.indexOf(i) >= 0; });
    if (both.length) {
      return { i: both[both.length - 1], why: '' };
    }

    if (byH.length && byW.length) {
      var h = byH[byH.length - 1], w = byW[byW.length - 1];
      var big = Math.max(h, w), small = Math.min(h, w);
      return {
        i: big,
        why: 'Your height points to ' + rows[small].size + ' and your weight to ' +
             rows[big].size + '. We show the larger of the two.'
      };
    }

    if (byW.length) return { i: byW[byW.length - 1], why: 'Based on your weight — your height sits outside the range this piece is cut for.' };
    if (byH.length) return { i: byH[byH.length - 1], why: 'Based on your height — your weight sits outside the range this piece is cut for.' };

    /* Fora da tabela inteira. Diz isso em vez de empurrar a ponta. */
    var last = rows.length - 1;
    if (kg > rows[last].w.hi) {
      return { i: last, why: 'You are above the range this piece is made for, so ' + rows[last].size + ' is the largest it goes — it may be close.', edge: true };
    }
    return { i: 0, why: 'You are below the range this piece is made for, so ' + rows[0].size + ' is the smallest it goes — it will sit loose.', edge: true };
  }

  /* ------------------------------------------------------------------- UI */
  var form = root.querySelector('[data-fit-form]');
  var out = root.querySelector('[data-fit-out]');
  var units = root.querySelectorAll('[data-fit-unit]');
  var imperial = true;

  function setUnits(next) {
    imperial = next;
    units.forEach(function (b) {
      var on = (b.getAttribute('data-fit-unit') === 'imperial') === imperial;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-fit-imperial]').forEach(function (el) { el.hidden = !imperial; });
    root.querySelectorAll('[data-fit-metric]').forEach(function (el) { el.hidden = imperial; });
    out.hidden = true;
  }

  units.forEach(function (b) {
    b.addEventListener('click', function () { setUnits(b.getAttribute('data-fit-unit') === 'imperial'); });
  });

  function val(sel) {
    var el = root.querySelector(sel);
    var n = el ? parseFloat(el.value) : NaN;
    return isNaN(n) ? 0 : n;
  }

  function read() {
    if (imperial) {
      return {
        cm: (val('[data-fit-ft]') * 12 + val('[data-fit-in]')) * 2.54,
        kg: val('[data-fit-lb]') * 0.45359237
      };
    }
    return { cm: val('[data-fit-cm]'), kg: val('[data-fit-kg]') };
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var m = read();

    if (m.cm <= 0 || m.kg <= 0) {
      out.hidden = false;
      out.className = 'fit__out fit__out--ask';
      out.textContent = 'Fill in both your height and your weight.';
      return;
    }

    var r = pick(m.cm, m.kg);
    var row = rows[r.i];

    var html = '<p class="fit__size">Your size: <strong>' + row.size + '</strong></p>';
    if (r.why) html += '<p class="fit__why">' + r.why + '</p>';
    if (row.chest) html += '<p class="fit__why">' + row.size + ' measures ' + row.chest + ' around the chest, garment laid flat.</p>';
    html += '<p class="fit__fine">This is the manufacturer’s guidance for a body like yours, not a measurement of you. If it matters, check the garment against something you already own in the size chart.</p>';

    out.hidden = false;
    out.className = 'fit__out' + (r.edge ? ' fit__out--edge' : '');
    out.innerHTML = html;
  });

  /* Abre a gaveta da tabela e fecha esta. As duas respondem perguntas
     diferentes e nao devem ficar empilhadas. */
  var toChart = root.querySelector('[data-fit-chart]');
  var chart = document.getElementById('SizeChart');
  if (toChart) {
    if (chart) {
      toChart.addEventListener('click', function () {
        drawer.close();
        setTimeout(function () { chart.open(); }, 180);
      });
    } else {
      toChart.hidden = true;
    }
  }

  /* ------------------------------------------------- o botao na linha de tamanho
   * <vg-drawer> liga os botoes no connectedCallback, varrendo o DOM uma vez.
   * Um botao inserido depois nunca seria ligado — por isso chamamos .open()
   * direto, que o elemento expoe.
   */
  var anchor = document.querySelector('.size-chart__trigger');
  if (anchor && anchor.parentNode) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'size-chart__trigger fit__trigger';
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>Find my size';
    btn.addEventListener('click', function () { drawer.open(); });
    anchor.parentNode.insertBefore(btn, anchor);

    /* 02/11 — dois botoes na mesma linha disputavam a mesma duvida. O "Size
       guide" sai e a tabela passa a ser alcancada de dentro desta janela, pelo
       "View size chart". A remocao vem DEPOIS de inserir o novo e so quando a
       gaveta da tabela existe: se este script falhar antes daqui, o botao
       antigo continua no lugar e ninguem fica sem tabela. */
    if (chart) anchor.remove();
  }

  setUnits(true);
})();
